// eslint-disable-next-line import/no-unassigned-import
import "@novalabsxyz/tenants/runtime-config";

import { getEnvValue } from "@novalabsxyz/utils/env";
import { yup } from "@novalabsxyz/utils/yup";

export const Config = {
  AgwApiBaseUrl: getEnvValue("API_URL", yup.string().required()),
};
